







































import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../system";
import WorkflowEditor from "../editors/WorkflowEditor.vue";
import { ReceptionEditViewMixin } from "../mixins";

@Component({
  components: {
    WorkflowEditor,
  }
})
export default class WorkflowReceptionDetailEditDialog extends Mixins(ReceptionEditViewMixin, DialogMixin) {
  isConfirmed: boolean = false;

  async show(receptionDetailId: number): Promise<WorkflowReceptionDetailEditDialog> {
    if (!receptionDetailId) {
      this.$error("依頼詳細編集失敗", "依頼詳細番号が設定されていません。");
      return null;
    }

    await this.getReceptionDetail(receptionDetailId);
    if (!!this.reception) {
      return this.showModal(async () => {
        this.isConfirmed = false;
        await this.waitHidden();
        return this;
      });
    }
    return null;
  }

  async confirm(): Promise<void> {
    this.isLoading = true;
    if (await this.registerDetail(false)) {
      this.isConfirmed = true;
      this.isVisible = false;
      this.notifyMessage("receptionRegistered");
    }
    this.isLoading = false;
  }

  close(): void {
    this.isVisible = false;
  }
}
